import * as angular from 'angular';

import { CheckboxToggle } from './checkbox-toggle.component';

export const CheckboxToggleModule = angular
  .module('checkbox-toggle', [])
  .component('checkboxToggle', CheckboxToggle).name;
